/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const GermanFlagIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5 3"
    width="1.1em"
    height="1.1em"
  >
    <path d="M0 0h5v3H0z"/>
    <path fill="#D00" d="M0 1h5v2H0z"/>
    <path fill="#FFCE00" d="M0 2h5v1H0z"/>
  </svg>

);

export const GermanFlagIcon = (props) => (
  <Icon component={GermanFlagIconSvg} {...props} />
);
